// SALDP white-labelling. Added by Sullivan Digital, 2026-10-26. Licensed under the GNU AGPL v3; see LICENSE-AGPL.txt.
import type { ComponentType } from "react";

import { NotFound } from "metabase/common/components/ErrorPages";

/**
 * This fork removes Metabase's upsells. Upsell components are passed through
 * here instead of being deleted, so upstream edits to them still merge.
 */
export function removedUpsell<Props extends object>(
  _upsell: ComponentType<Props>,
): (props: Props) => null {
  return function RemovedUpsell() {
    return null;
  };
}

/** Like `removedUpsell`, for a page that exists only to upsell: it is not found. */
export function removedUpsellPage<Props extends object>(
  _upsell: ComponentType<Props>,
): (props: Props) => JSX.Element {
  return function RemovedUpsellPage() {
    return <NotFound />;
  };
}
